import { Alert, AlertTitle, Typography } from "@mui/material";
import React from "react";
import { ErrorDisplayProps } from "./ErrorDisplayProps";

export const ErrorDisplay = ({ message }: ErrorDisplayProps) => {
    return (
        <>
            {
                message && (
                    <Alert severity='error' sx={{ maxWidth: '100%' }} >
                        <AlertTitle>Error</AlertTitle>
                        <Typography variant='subtitle2' gutterBottom>
                            {message}
                        </Typography>
                    </Alert>
                ) 
            }
        </>);
}